import React from 'react';
import { motion } from 'framer-motion';
import { Leaf, Sparkles, Droplets } from 'lucide-react';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-botanical-ivory px-4 pt-16 pb-8 md:pt-24 md:pb-12" data-id="element-89">
      {/* Decorative Background Elements */}
      <div className="absolute top-10 left-10 text-botanical-sage/20 animate-float" data-id="element-90">
        <Leaf size={120} strokeWidth={1} data-id="element-91" />
      </div>
      <div className="absolute bottom-20 right-10 text-botanical-gold/10 animate-float-delayed" data-id="element-92">
        <Sparkles size={150} strokeWidth={1} data-id="element-93" />
      </div>
      <div className="absolute top-1/3 right-20 text-botanical-terracotta/10 animate-float" data-id="element-94">
        <Droplets size={80} strokeWidth={1} data-id="element-95" />
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-96">
        {/* Text Content */}
        <div className="text-center mb-10 md:mb-14" data-id="element-97">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-98">
            <span className="inline-block text-botanical-terracotta font-lora italic tracking-wider mb-6 text-sm md:text-base" data-id="element-99">
              La Alquimia de tu Belleza Esencial
            </span>
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-playfair font-medium text-botanical-forest leading-tight mb-8" data-id="element-100">
              5 Recetas Naturales Fáciles
            </h1>
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="text-lg md:text-2xl text-botanical-forest/80 font-lora max-w-3xl mx-auto leading-relaxed mb-10" data-id="element-101">
            Recupera el brillo natural de tu piel en 20 minutos con el Método
            del Triángulo Maestro: ciencia botánica, ingredientes puros y
            rituales de bienestar al alcance de tus manos.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4,
          ease: 'easeOut'
        }} data-id="element-102"></motion.div>
        </div>

        {/* Hero Product Image */}
        <motion.div initial={{
        opacity: 0,
        y: 40,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.6,
        ease: 'easeOut'
      }} className="relative mx-auto max-w-4xl" data-id="element-103">
          <div className="relative rounded-lg overflow-hidden shadow-2xl shadow-botanical-forest/10" data-id="element-104">
            <img src="https://cdn.magicpatterns.com/uploads/tSeef7ssfAEG4TnV6NhiB6/kling_20260323_作品_High_end_d_1732_5.png" alt="Guía Piel de Seda — 5 Recetas Naturales mostrada en laptop, tablet y teléfono" className="w-full h-auto object-cover" data-id="element-105" />
          </div>
          {/* Subtle glow behind the image */}
          <div className="absolute -inset-4 bg-botanical-gold/5 rounded-2xl blur-3xl -z-10" data-id="element-106" />
        </motion.div>
      </div>
    </section>;
}